import * as React from "react";
import { Subject, StudyScheduleVisit, StudyScheduleSession } from "webportalclient";
import { useWebPortalApiClient } from "../../misc/api/WebPortalTokenClient";

export const useVisitScheduleCascades = (studyId: string, originalSessionLabel: string, selectedVisit: string, originalVisitId: string, siteId: string = undefined) => {
    const client = useWebPortalApiClient();
    const [subjects, setSubjects] = React.useState<Subject[]>([]);
    const [visits, setVisits] = React.useState<StudyScheduleVisit[]>([]);
    const [sessions, setSessions] = React.useState<StudyScheduleSession[]>([]);
    const [loading, setLoading] = React.useState<boolean>(false);
    const emptyString = "";

    const fetchSubjects = async () => {
        let subjects = null;
        if (siteId === undefined)
            subjects = await client.client.getSubjects("id,number", `site/studyId eq ${studyId}`, "number", "site");
        else
            subjects = await client.client.getSubjects("id,number", `siteId eq ${siteId}`, "number");

        setSubjects(subjects.value);
    };

    const fetchVisits = async (studyId: string) => {
        const visits = await client.client.getStudyScheduleVisits("id,label", `studySchedule/studyId eq ${studyId}`, `label asc`);

        setVisits(visits.value);
    };

    const fetchSession = async (studyScheduleVisitId: string) => {
        const session = await client.client.getStudyScheduleSessions("id,label,sessionTypeId,studyScheduleVisitId", `studyScheduleVisitId eq ${studyScheduleVisitId} and label eq '${originalSessionLabel}'`, `label asc`);

        return session.value[0];
    }

    const resolveFilters = (visitFilter: string, sessionTypeFilter: string): string => {
        if (visitFilter !== emptyString && sessionTypeFilter !== emptyString)
            return `${visitFilter} and ${sessionTypeFilter}`;

        if (visitFilter !== emptyString)
            return visitFilter;

        if (sessionTypeFilter !== emptyString)
            return sessionTypeFilter;

        return undefined;
    }

    const fetchSessions = async (originalSession: StudyScheduleSession, visitId: string) => {
        let visitFilter = !!visitId ? `studyScheduleVisitId eq ${visitId}` : "";
        let sessionTypeFilter = (!!originalSession ? ` sessionTypeId eq '${originalSession.sessionTypeId}'` : "")
        let filters = resolveFilters(visitFilter, sessionTypeFilter);

        const sessionsResponse = await client.client.getStudyScheduleSessions("id,label", filters);

        setSessions(sessionsResponse.value);       
    };

    React.useEffect(
        () => {
            const fetchEntities = async () => {
                setLoading(true);
                await fetchSubjects();
                await fetchVisits(studyId);
                const originalSession = await fetchSession(originalVisitId);
                await fetchSessions(originalSession, selectedVisit);
                setLoading(false);
            };

            fetchEntities();
        },
        [selectedVisit, originalSessionLabel]
    );

    return { subjects, visits, sessions, loading };
}
